import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Link as ScrollLink } from 'react-scroll';
import content from '../content';
import './common.css';
import { FaGithubSquare, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export default function Navigation() {
	return (
		<div
			style={{
			    // background: '#091C29',
				background: 'rgb(9,24,42)',
			}}
			className="font-dosis fixed top-0 w-screen z-40"
		>
			<div className="flex items-center w-10/12  mx-auto py-3">
				<div className="text-3xl  font-bold text-white flex-1 cursor-pointer">
					{/* <h1>
            {content.nav.logo}
            <span className="h-3 w-3 bg-red-400 inline-block ml-2  rounded-full"></span>
          </h1> */}
					{/* {content.contact.socials.map((social, index) => {
						return (
							<LazyLoadImage
								effect="blur"
								// className={`m-2 ${index % 2 !== 0 ? 'animate-bounce' : 'animate-bounceFirst'}`}
								className="m-2"
								style={{ marginTop: '20px' }}
								width="30px"
								key={index}
								src={social.img}
								alt={social.alt}
							/>
						);
					})} */}

					<ul className="header__ul">
						<a href="https://github.com/bhowmiktiasha" target = "_blank" >
							<li>
								<FaGithubSquare className="headerIcon" />
							</li>
						</a>

						<a href="https://www.linkedin.com/in/tiasha-bhowmik-b78692169/" target = "_blank">
						<li>
							<FaLinkedin className="headerIcon" />
						</li>
						</a>

						<a href="mailto:itstia987@gmail.com" target="_blank">
						<li>
							<FaEnvelope className="headerIcon" />
						</li>
						</a>
					</ul>
				</div>

				<div className="text-white text-xl">
					{content.nav.links.map((link, index) => {
						return (
							<ScrollLink to={link.to} smooth={true}>
								<span className="mr-4 cursor-pointer" key={index}>
									{link.text}
								</span>
							</ScrollLink>
						);
					})}
				</div>
			</div>
		</div>
	);
}
